import axios from '../../../lib/axios';

// const API_BASE_URL = 'https://www.whysocial.in/api';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const authService = {
  register: async (userData) => {
    try {
      console.log('API Call - Signup with data:', userData);
      const response = await axios.post(`${API_BASE_URL}/signup/`, userData);
      console.log('API Response - Signup success:', response.data);
      return response.data;
    } catch (error) {
      console.error('API Error - Signup failed:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.response?.data?.message || error.message
      });
      throw error;
    }
  },

  login: async (email, password) => {
    try {
      console.log('API Call - Login with email:', email);
      const response = await axios.post(`${API_BASE_URL}/login/`, { email, password });
      console.log('API Response - Login success:', response.data);
      // Store tokens if provided
      if (response.data.access_token) {
        localStorage.setItem('accessToken', response.data.access_token);
      }
      if (response.data.refresh_token) {
        localStorage.setItem('refreshToken', response.data.refresh_token);
      }
      return response.data;
    } catch (error) {
      console.error('API Error - Login failed:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.response?.data?.message || error.message
      });
      throw error;
    }
  },

  verifyOtp: async (email, otp) => {
    try {
      console.log('API Call - Verify OTP for email:', email);
      const response = await axios.post(`${API_BASE_URL}/login/verify-otp/`, { email, otp });
      console.log('API Response - OTP verification success:', response.data);
      // Store tokens if provided
      if (response.data.access_token) {
        localStorage.setItem('accessToken', response.data.access_token);
      }
      if (response.data.refresh_token) {
        localStorage.setItem('refreshToken', response.data.refresh_token);
      }
      return response.data;
    } catch (error) {
      console.error('API Error - OTP verification failed:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.response?.data?.message || error.message
      });
      throw error;
    }
  },

  activateAccount: async (token, password, confirmPassword) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/activate-account/`, {
        token,
        password,
        confirm_password: confirmPassword,
      });
      return response.data;
    } catch (error) {
      console.error('API Error - Account activation failed:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.response?.data?.message || error.message
      });
      throw error;
    }
  },

  verifyActivationToken: async (token) => {
    try {
      console.log('Verifying activation token:', token);
      const response = await axios.get(`${API_BASE_URL}/activate-account/${token}/`);
      console.log('Token verification response:', response.data);
      return response.data;
    } catch (error) {
      console.error('API Error - Token verification failed:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.response?.data?.message || error.message
      });
      throw error;
    }
  },

  logout: () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('rememberedEmail');
  },

  forgotPassword: async (email) => {
    try {
      console.log('API Call - Forgot password for email:', email);
      const response = await axios.post(`${API_BASE_URL}/auth/forgot-password`, { email });
      console.log('API Response - Forgot password request:', response.data);
      return response.data;
    } catch (error) {
      console.error('API Error - Forgot password failed:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.response?.data?.message || error.message
      });
      throw error;
    }
  },

  resetPassword: async (uid, token, password, confirmPassword) => {
    try {
      console.log('API Call - Reset password with uid:', uid);
      const response = await axios.post(`${API_BASE_URL}/auth/reset-password`, {
        uid,
        token,
        password,
        confirm_password: confirmPassword
      });
      console.log('API Response - Reset password success:', response.data);
      return response.data;
    } catch (error) {
      console.error('API Error - Reset password failed:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.response?.data?.message || error.message
      });
      throw error;
    }
  },
};

// Mock service for development/testing
export const mockAuthService = {
  register: (data) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        console.log('Mock signup:', data);
        if (!data.email || !data.fullname) {
          reject(new Error('Email and fullname are required'));
        } else {
          resolve({ success: true, message: 'Registration successful' });
        }
      }, 1500);
    });
  },

  login: (email, password) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        console.log('Mock login:', email);
        if (!email || !password) {
          reject(new Error('Email and password are required'));
        } else {
          resolve({ success: true, message: 'Login successful' });
        }
      }, 1500);
    });
  },

  verifyOtp: (email, otp) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        console.log('Mock OTP verification:', email, otp);
        if (!otp || otp.length !== 6) {
          reject(new Error('Invalid OTP'));
        } else {
          resolve({
            success: true,
            access_token: 'mock-access-token',
            refresh_token: 'mock-refresh-token',
            user: {
              tenant_id: 'mock-tenant-id',
              fullname: 'John Doe',
              email: email,
              role: 'Scientist / Analyst'
            }
          });
        }
      }, 1000);
    });
  },

  activateAccount: (token, password, confirmPassword) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        console.log('Mock account activation:', token);
        if (password !== confirmPassword) {
          reject(new Error('Passwords do not match'));
        } else if (password.length < 8) {
          reject(new Error('Password must be at least 8 characters'));
        } else {
          resolve({ success: true, message: 'Account activated successfully' });
        }
      }, 1500);
    });
  },

  logout: () => {
    console.log('Mock logout');
  }
};